import React from "react";

const Error401Page = () => (
  <>
    <strong>401.</strong> Vous n'étes pas autorisées à accèder à cette page
  </>
);

export default Error401Page;
